// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"FooterTips_thecomp___A2Wp"};